/* Loading state of the match page (MatchDetail): a shimmering skeleton in the page's own layout —
 * scoreboard header, tab bar, stats + controls columns — instead of a "Loading…" line, so the
 * page fades in where it will appear. Screen readers get one status message. */
import React from 'react';
import { useTranslation } from 'react-i18next';
import './matchDetailSkeleton.css';

const B = ({ w, h, r, style }) => <span className="mds-b" style={{ width: w, height: h, borderRadius: r, ...style }} />;

export default function MatchDetailSkeleton() {
  const { t } = useTranslation();
  return (
    <div className="mds" role="status" aria-busy="true" aria-live="polite">
      <span className="mds-sr">{t('matchDetail.loading', 'Loading match details…')}</span>

      {/* scoreboard header */}
      <div className="mds-card mds-header">
        <div className="mds-row mds-between"><B w={70} h={12} /><B w={90} h={22} r={999} /></div>
        <div className="mds-teams">
          <div className="mds-team"><B w={64} h={64} r={14} /><B w={120} h={14} /><B w={60} h={10} /></div>
          <div className="mds-score">
            <B w={48} h={44} r={10} /><span className="mds-colon">:</span><B w={48} h={44} r={10} />
          </div>
          <div className="mds-team"><B w={64} h={64} r={14} /><B w={120} h={14} /><B w={60} h={10} /></div>
        </div>
        <div className="mds-row mds-center"><B w={70} h={20} r={999} /><B w={70} h={20} r={999} /><B w={70} h={20} r={999} /></div>
      </div>

      {/* access / info strip */}
      <div className="mds-card mds-strip"><B w={140} h={12} /><B w="38%" h={30} r={8} /><B w="38%" h={30} r={8} /></div>

      {/* tabs */}
      <div className="mds-tabs"><B w={110} h={32} r={8} /><B w={140} h={32} r={8} /><B w={130} h={32} r={8} /><B w={100} h={32} r={8} /></div>

      {/* columns */}
      <div className="mds-cols">
        <div className="mds-card mds-col">
          <B w={130} h={12} />
          {[0, 1, 2, 3, 4, 5].map(i => (
            <div key={i} className="mds-line"><B w={22} h={22} r={6} /><B w="34%" h={11} /><B w="12%" h={11} style={{ marginLeft: 'auto' }} /><B w="12%" h={11} /></div>
          ))}
        </div>
        <div className="mds-card mds-col">
          <B w={110} h={12} />
          <div className="mds-btns">{[0, 1, 2, 3, 4].map(i => <B key={i} w="100%" h={34} r={8} />)}</div>
          <B w={90} h={10} style={{ marginTop: 6 }} />
          <div className="mds-btns two"><B w="100%" h={34} r={8} /><B w="100%" h={34} r={8} /></div>
        </div>
      </div>
    </div>
  );
}
